import axios from 'axios'
import { BASE_API } from '@/api/v1'

/** Lee el token del localStorage — igual que axiosConfig.setHeaders() pero sin efectos secundarios */
const authHeader = () => {
  const token     = window.localStorage.getItem('accessToken')
  const tokenType = window.localStorage.getItem('tokenType')
  return { Authorization: `${tokenType} ${token}` }
}

export default {
  namespaced: true,

  state: {
    items: [],
    loading: false,
  },

  getters: {
    noLeidas: state => state.items.filter(n => !n.leida).length,
  },

  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    MARK_READ(state, id) {
      const n = state.items.find(i => i.id === id)
      if (n) n.leida = true
    },
    MARK_ALL_READ(state) {
      state.items.forEach(n => { n.leida = true })
    },
    REMOVE(state, id) {
      state.items = state.items.filter(i => i.id !== id)
    },
  },

  actions: {
    async fetchNotificaciones({ commit }) {
      commit('SET_LOADING', true)
      try {
        const res = await axios.get(`${BASE_API}/notificaciones`, { headers: authHeader() })
        commit('SET_ITEMS', res.data)
      } catch (e) {
        // silencioso — no interrumpir la UI si falla el polling
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async marcarLeida({ commit }, id) {
      try {
        await axios.post(`${BASE_API}/notificacion-leida/${id}`, {}, { headers: authHeader() })
        commit('MARK_READ', id)
      } catch (e) {
        console.error('Error marcando notificación:', e)
      }
    },

    async marcarTodasLeidas({ commit }) {
      try {
        await axios.post(`${BASE_API}/notificaciones-leidas`, {}, { headers: authHeader() })
        commit('MARK_ALL_READ')
      } catch (e) {
        console.error('Error marcando todas como leídas:', e)
      }
    },

    async eliminar({ commit }, id) {
      try {
        await axios.delete(`${BASE_API}/notificacion/${id}`, { headers: authHeader() })
        commit('REMOVE', id)
      } catch (e) {
        console.error('Error eliminando notificación:', e)
      }
    },
  },
}
